import axios from 'axios'
import { LoginRequest, LoginResponse } from '../interfaces/api/UserApi'
import User from '../interfaces/User'
import config from './../config'

export const userApi = {
    login: async (username: string, password: string) => {
        const body = { username, password } as LoginRequest
        return await axios.post<LoginResponse>(`${config.apiUrl}/user/login`, body)
    },
    refreshToken: async () => {
        const refreshToken = localStorage.getItem('refreshToken')
        const user = JSON.parse(localStorage.getItem('user')) as User
        console.log(refreshToken)
        return await axios.get<LoginResponse>(`${config.apiUrl}/user/refresh_token?refreshToken=${refreshToken}&username=${user.username}`)
    }
}

export const logout = () => {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('user')
    // eslint-disable-next-line no-restricted-globals
    location.reload()
}
